import { CoreTokenTypes } from './tokens';
import isNil from './util/isNill';
import { getFinalRollConfig } from './util/rollConfig';
function createTallyRolls(plugins, config) {
    function tallyRolls(tokens, rolls, configOverrides) {
        var finalConfig = getFinalRollConfig(config, configOverrides);
        return tokens.map(function (token, index) {
            switch (token.type) {
                case CoreTokenTypes.CloseParen:
                case CoreTokenTypes.OpenParen:
                case CoreTokenTypes.Operator:
                    if (rolls[index])
                        throw new Error("Roll result array does not match provided tokens. Got results but expected null at position " + index);
                    return null;
                case CoreTokenTypes.DiceRoll:
                    var rollsForToken = rolls[index];
                    if (isNil(rollsForToken))
                        throw new Error("Roll result array does not match provided tokens. Got null but expected results at position " + index);
                    return plugins[token.detailType].calculateValue(token.detail, rollsForToken, finalConfig);
            }
        });
    }
    return tallyRolls;
}
export default createTallyRolls;
